import { render } from "./VariableRateSowingSugarbeetIcon.vue?vue&type=template&id=93ec0fd2"
import script from "./VariableRateSowingSugarbeetIcon.vue?vue&type=script&lang=js"
export * from "./VariableRateSowingSugarbeetIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__